export default __webpack_public_path__ + "static/media/misc-drawerB-1440w.24124e26.avif";